import React, { lazy } from 'react';
// Blocks
import PanelDefaultModel from './components/model/panels/PanelDefaultModel.js';
import PanelTextModel from './components/model/panels/PanelTextModel.js';
import PanelFooterLinksModel from '../App/components/view/PanelFooterLinksModel.js';
import PanelSliderModel from './components/model/panels/PanelSliderModel.js';
import PanelHelpModel from './components/model/panels/PanelHelpModel.js';
import PanelDisclaimerModel from './components/model/panels/PanelDisclaimerModel.js';

// const PanelDefault = lazy(() => import('./components/model/panels/PanelDefault'));
// const PanelText = lazy(() => import('./components/model/panels/PanelText'));
// const PanelFooterLinks = lazy(() => import('../App/components/view/PanelFooterLinks'));
// const PanelMainMenu = lazy(() => import('../App/components/menu/PanelMainMenu'));
// const PanelCategory = lazy(() => import('../Product/components/view/PanelCategory'));
// const PanelRecommandation = lazy(() => import('./components/model/panels/PanelRecommandation'));
// const PanelShipping = lazy(() => import('./components/model/panels/PanelShipping'));
// const PanelVoucherPopin = lazy(() => import('./components/model/panels/PanelVoucherPopin'));
// const PanelSlider = lazy(() => import('./components/model/panels/PanelSlider'));
import PanelDefault from './components/model/panels/PanelDefault';
import PanelText from './components/model/panels/PanelText';
import PanelFooterLinks from '../App/components/view/PanelFooterLinks';
import PanelSlider from './components/model/panels/PanelSlider';
import PanelHelp from './components/model/panels/PanelHelp';
import PanelDisclaimer from './components/model/panels/PanelDisclaimer';

export const CMS_PANEL_MODELS = [
	PanelDefaultModel,
	PanelTextModel,
	PanelSliderModel,
	PanelHelpModel,
	PanelDisclaimerModel,
	PanelFooterLinksModel,
];
export const CMS_PANEL_MODEL_DEFAULT = PanelDefault;

export function getPanelModelViewer(model) {
	switch(model) {
	// Add custom model page
	// case 'xyz':
	//     return <PageXyz page={this.props.page} />;

	case 'footerLinks':
		return PanelFooterLinks;

	case 'slider':
		return PanelSlider;

	case 'help':
		return PanelHelp;

	case 'disclaimer':
		return PanelDisclaimer;

	case 'text':
		return PanelText;

	case 'default':
	default:
		return PanelDefault;
	}
}
